import { Text, TextProps } from '@chakra-ui/react'
import { Format, ScalarContentNode } from '@helo/cms'
import { merge } from 'lodash'

import { ConditionalLink } from '../../components/Link/Link'
import { InlineSkeleton } from '../../components/SkeletonLoader'
import { ConditionalTooltip } from '../../components/Tooltip/Tooltip'
import { withUnicodeRouteArrow } from '../../utils/routeLabelDisplay'
import { pillStyles } from '../utils'

interface IDRendererProps {
  contentNode: ScalarContentNode
  isLoading?: boolean
}

export const IDRenderer = ({ contentNode, isLoading }: IDRendererProps) => {
  const data = contentNode.data as any
  const { size, linkUrlStorage, linkUrl, _tooltip, textCase, styles } =
    contentNode.state
  const capitalizeStyles: TextProps =
    textCase === 'all'
      ? { textTransform: 'uppercase' }
      : textCase === 'word'
        ? { textTransform: 'capitalize' }
        : {}

  // Extract styles object if it exists and is an object
  const customStyles = styles && typeof styles === 'object' ? styles : {}

  return (
    <ConditionalTooltip
      isDisabled={!data || isLoading}
      tooltipOptions={_tooltip as any}
    >
      <ConditionalLink
        isDisabled={!data || isLoading}
        to={linkUrl as any}
        search={linkUrlStorage as any}
      >
        <Text
          size={size}
          {...(linkUrl && pillStyles)}
          {...capitalizeStyles}
          {...customStyles}
        >
          <InlineSkeleton isLoading={isLoading}>
            {withUnicodeRouteArrow(Format.id(contentNode.state)(data))}
          </InlineSkeleton>
        </Text>
      </ConditionalLink>
    </ConditionalTooltip>
  )
}
